//make jQuery accessible globally.
window.jQuery = require('jquery');
window.$ = jQuery;

window.Popper = require('popper.js');
require('bootstrap');
const waypoints = require('./waypoints.js');
const { isInsideElement } = require('../lib/utils/dom-utils.js');
const { scrollToTop } = require('../lib/utils/scroll-utils.js');
const { default: globalTranslationService } = require('../../../../js/global-translation/global-translation-service.js');
window.globalTranslationService = globalTranslationService;

import { loadScripts, loadDelayedScripts } from './index-module.js';
import debounce from 'lodash/debounce';

window.addEventListener("DOMContentLoaded", () => {
    (async () => {
        await loadScripts();
    })();

    //Scroll listener to only load charts scripts below the fold
    const loadScriptsScrollListener = debounce(() => {
        const heightOffset = window.innerHeight / 4;
        const ScrolledTop = window.pageYOffset || document.documentElement.scrollTop
        if (ScrolledTop > heightOffset) {
            (async () => {
                await loadDelayedScripts();
            })();
            return window.removeEventListener("scroll", loadScriptsScrollListener);
        }
    }, 100);
    window.addEventListener("scroll", loadScriptsScrollListener);
    loadScriptsScrollListener(); //trigger it once anyway, incase the page is already scrolled down.
})

/* eslint-disable no-undef */
function menuScripts() {
    /* eslint-enable max-len */

  // SiteHeader
  $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu', (event) => {
    if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
      event.stopPropagation();
    }
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu-toggle', () => {
    scrollToTop();
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__submenu .list-group-item-action', (event) => {
    event.stopPropagation();
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__submenu', (event) => {
    if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
      event.stopPropagation();
    }
  });

  $('.site-header__submenu-action').on('mouseenter', (event) => {
    const actionElement = $(event.target),
          menuId = actionElement.attr('data-menu'),
          descriptionId = actionElement.attr('data-description'),
          currentActiveAction = $('#' + menuId + ' .list-group .list-group-item.active'),
          currentActivePane = $('#' + menuId + ' .site-header__submenu-content .tab-pane.active'),
          targetPane = $('#' + menuId + ' .site-header__submenu-content .tab-pane#' + descriptionId);

    $('#' + menuId + ' .site-header__submenu-content').attr('data-pane', currentActiveAction.attr('data-default'));
    currentActivePane.removeClass('show active');
    targetPane.tab("show");
    actionElement.tab("show");
    currentActiveAction.removeClass('active');
  });

  $('.site-header .navbar-toggler').on('click', (event) => {
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    toggleElement.toggleClass('collapsed');
    targetElement.toggleClass('show');
  });

  $('.site-header__mobile-submenu-toggle').on('click', (event) => {
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    targetElement.toggleClass('show');
  });


  $('.site-header__mobile-sub-submenu-toggle').on('click', (event) => {
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    targetElement.toggleClass('show');
  });

}

document.addEventListener('dynamicMenuLoaded', menuScripts);

  waypoints.init();
  waypoints.sectionHeaderInit();
  waypoints.tableHeaderInit();


/* scroll to top */
$(window).scroll(function() {
  if ($(window).scrollTop() >= $('main').offset().top + $('main').outerHeight() - window.innerHeight) {
    $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'visible' });
    $('.scroll-to-top').addClass('table-sticky').removeClass('sticky-fixed');
  }
  else if ($(this).scrollTop() < 100) {
    $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'hidden' });
  }
  else {
    $('.scroll-to-top').css({ 'animation': 'fadeOut 0s', 'visibility': 'visible' });
    $('.scroll-to-top').addClass('sticky-fixed').removeClass('table-sticky');
  }
});

$('.scroll-to-top').on('click', function() {
  $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'hidden' });
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

/* sticky nav shadow */
$('.site-header__nav-item').hover(function() {
  $('.site-header.sticky').css('z-index', 1060);
}, function() {
  $('.site-header.sticky').css('z-index', 1020);
});
